export const defaultTimeout = 0.0048;
export const monthTimeout = 30;

// Записать куки
export const setCookie = (
  cookieName,
  cookieValue,
  expireDays = defaultTimeout,
) => {
  const date = new Date();
  const dateTime = new Date(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
  const expires = `expires=${dateTime.toUTCString()}`;
  document.cookie = `${cookieName}=${cookieValue};${expires};path=/`;
};

// Получить куки
export const getCookie = cname => {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }

  return false;
};
